import { Audiotrack, BrokenImage, Image } from '@mui/icons-material';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import MoodOutlinedIcon from '@mui/icons-material/MoodOutlined';
import { CardMedia, Icon } from '@mui/material';
import CallToActionItemPreview from 'app/callToAction/CallToActionItemPreview';
import DiscountCard from 'app/event/eventForm/eventFormExtras/eventExtraDiscounts/DiscountCard';
import ChyronPreview from 'app/stickers/components/chyron/ChyronPreview';
import StickerItemPreview from 'app/stickers/StickerItemPreview';
import AssetType from 'common/enums/assetTypes';
import StickerType from 'common/enums/stickersTypes';
import VodClip from 'common/features/videoPlayer/VodClip';

export const getAssetImage = (asset, className = '') => {
    if (asset.type === AssetType.MULTIMEDIA) {
        if (asset.format.startsWith('image') || asset.format === 'application/immersive') {
            return asset.url ? <img src={asset.url} alt={asset.description} /> : <Image />;
        }
        if (asset.format.startsWith('audio')) {
            return <Audiotrack className={className} />;
        }
        if (asset.format.startsWith('video')) {
            const media = asset.vodUrl ? <VodClip src={asset.vodUrl} /> : <video src={asset.url} />;
            return (
                <div className={className}>
                    <CardMedia title={asset.name} component="div">
                        {media}
                    </CardMedia>
                </div>
            );
        }
        if (asset.format.startsWith('application')) {
            if (asset.status === 'ready' && asset?.slides.length) {
                return <img src={asset.slides[0]} alt={asset.name} />;
            } else {
                return <Image className={className} />;
            }
        }
    }
    if (asset.type === AssetType.SURVEY) {
        return <LiveHelpOutlinedIcon className={className} />;
    }
    if (asset.type === AssetType.QUIZ) {
        return <MoodOutlinedIcon className={className} />;
    }
    if (asset.type === AssetType.PRODUCT || asset.type === AssetType.GIFT) {
        return asset.images?.length ? (
            <img src={asset.images[0]} alt={asset.description} />
        ) : (
            <Image className={className} />
        );
    }
    if (asset.type === AssetType.CALL_TO_ACTION) {
        return (
            <div className={className}>
                <CallToActionItemPreview size="medium" callToAction={asset} disabled={true} />
            </div>
        );
    }
    if (asset.type === AssetType.DISCOUNT) {
        return (
            <div className={className}>
                <DiscountCard asset={asset} />;
            </div>
        );
    }
    if (asset.type === AssetType.STICKER) {
        if (asset.stickerType === StickerType.CHYRON) {
            return <ChyronPreview asset={asset} />;
        }
        if (asset.stickerType === StickerType.POSTER) {
            return (
                <div className={className}>
                    <StickerItemPreview sticker={asset} />
                </div>
            );
        }
        return <Icon className={className}>label</Icon>;
    }
    return <BrokenImage />;
};
